module.exports = __webpack_public_path__ + "static/img/logo-BNG.5441287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awardTW/img/logo-BNG.png
// module id = bVrf
// module chunks = 1